import { ENVIRONMENT } from '../types/general';

/**
 * Determines the current environment based on the domain
 * @param domain - The domain to check (e.g., from FusionAuth config)
 * @returns The current environment (DEV, TST, UAT, or PRD)
 */
export function getEnvironment(domain: ENVIRONMENT): ENVIRONMENT {
  if (domain.includes(ENVIRONMENT.DEV)) return ENVIRONMENT.DEV;
  if (domain.includes(ENVIRONMENT.TST)) return ENVIRONMENT.TST;
  if (domain.includes(ENVIRONMENT.UAT)) return ENVIRONMENT.UAT;

  return ENVIRONMENT.PRD;
}
